<template>
  <div class="qhatu-page home-page">
    <section class="welcome-card qhatu-card">
      <div class="welcome-copy">
        <span class="welcome-kicker">Portal de clientes</span>
        <h1>Hola, {{ firstName }}</h1>
        <p>Consulta tus dashboards, reportes y opciones habilitadas desde un solo lugar.</p>
      </div>
      <div class="welcome-icon"><i class="bi bi-bar-chart-line"></i></div>
    </section>

    <section class="section-heading">
      <div>
        <h2>Accesos disponibles</h2>
        <p>Selecciona un módulo para comenzar.</p>
      </div>
      <span class="access-count">{{ visibleCategories.length }} opciones</span>
    </section>

    <section class="search-strip qhatu-card">
      <label class="search-box" for="buscarModulo">
        <i class="bi bi-search"></i>
        <input
          id="buscarModulo"
          v-model.trim="searchTerm"
          type="text"
          placeholder="Buscar módulo, cliente u opción..."
          autocomplete="off"
        />
        <button v-if="searchTerm" type="button" class="search-clear" @click="searchTerm = ''" aria-label="Limpiar búsqueda">
          <i class="bi bi-x-lg"></i>
        </button>
      </label>
      <small class="search-help">Escribe y el listado se filtrará automáticamente.</small>
    </section>

    <div v-if="visibleCategories.length" class="access-grid">
      <button
        v-for="category in visibleCategories"
        :key="category.idCategoria"
        type="button"
        class="access-card qhatu-card"
        @click="openCategory(category)"
      >
        <span class="access-icon"><i :class="category.desIcono || 'bi bi-grid'"></i></span>
        <div class="access-copy">
          <span class="module-name">{{ formatText(category.modNombre) }}</span>
          <h3>{{ formatText(category.catNombre) }}</h3>
          <p>Ingresar a esta opción</p>
        </div>
        <i class="bi bi-arrow-up-right access-arrow"></i>
      </button>
    </div>

    <div v-else class="empty-card qhatu-card">
      <span class="empty-icon"><i :class="allCategories.length ? 'bi bi-search' : 'bi bi-hourglass-split'"></i></span>
      <h3>{{ allCategories.length ? 'No se encontraron resultados' : 'Estamos cargando tus accesos' }}</h3>
      <p>{{ allCategories.length ? 'Prueba con otro término de búsqueda para localizar tu tarjeta.' : 'En unos segundos verás aquí las opciones asignadas a tu perfil.' }}</p>
    </div>

    <section class="help-strip qhatu-card">
      <span class="help-icon"><i class="bi bi-shield-check"></i></span>
      <div>
        <strong>Acceso seguro</strong>
        <p>La información mostrada corresponde únicamente a los permisos asignados a tu usuario.</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BYInicio",
  data() {
    return {
      searchTerm: ""
    };
  },
  computed: {
    ...mapGetters("users", ["ModuloRapido", "NombresUsers"]),
    allCategories() {
      const seen = new Set();
      return this.ModuloRapido.filter(category => {
        if (category.catplataform != 2 || seen.has(category.idCategoria)) return false;
        seen.add(category.idCategoria);
        return true;
      });
    },
    visibleCategories() {
      const term = this.normalizeText(this.searchTerm);
      if (!term) return this.allCategories;
      return this.allCategories.filter(category => {
        const searchable = [category.modNombre, category.catNombre, category.desIcono]
          .map(value => this.normalizeText(value))
          .join(" ");
        return searchable.includes(term);
      });
    },
    firstName() {  

      return this.NombresUsers;
    },
  },
  methods: {
    normalizeText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },
    formatText(value) {
      if (!value) return "";
      return String(value).toLowerCase().replace(/(^|\s)\S/g, letter => letter.toUpperCase());
    },
    routeForCategory(category) {
      if (category.idCategoria === 2) return "/Home/configuracion";
      if (category.idCategoria == 3) return "/Home/accesos";
      if (category.idCategoria == 1) return "/Home/usuarios";
      if (category.idCategoria == 85) return "/Home/reportes";
      return `/Home/cliente/${category.idCategoria}`;
    },
    async openCategory(category) {
      const destination = this.routeForCategory(category);
      const isPowerBI = ![1, 2, 3, 85].includes(Number(category.idCategoria));

      if (!isPowerBI) {
        if (this.$route.path !== destination) {
          await this.$router.push(destination).catch(() => {});
        }
        return;
      }

      // Reinicia la bandera para garantizar el cambio false -> true al montar el dashboard.
      this.$store.commit("users/activarTokenbi", false);

      // Misma información utilizada por el menú lateral.
      this.$store.commit("users/llenarIdreporte", category.idReporte);
      this.$store.commit("users/llenarIdgrupo", category.idGrupo);
      sessionStorage.setItem("qhatu_powerbi_report", category.idReporte || "");
      sessionStorage.setItem("qhatu_powerbi_workspace", category.idGrupo || "");

      const payload = {
        idUsuario: localStorage.getItem("userId"),
        idModulo: category.idModulo,
        idCategoria: category.idCategoria
      };
      this.axios.post("BIClientes/RegistrarMonitoreo", payload).catch(() => {});

      // Primero se crea la vista del dashboard; después se dispara el embed.
      if (this.$route.path !== destination) {
        await this.$router.push(destination).catch(() => {});
      }

      await this.$nextTick();
      window.setTimeout(() => {
        this.$store.commit("users/activarTokenbi", true);
      }, 0);
    },
  },
};
</script>

<style scoped>
.home-page { display: grid; gap: 1.5rem; }
.welcome-card { position: relative; overflow: hidden; min-height: 210px; display: flex; align-items: center; justify-content: space-between; padding: clamp(1.5rem, 4vw, 3rem); color: #fff; border: 0; background: linear-gradient(120deg, #07519a, #0b6bc7 58%, #1390d2); }
.welcome-card::after { content: ""; position: absolute; width: 320px; height: 320px; border-radius: 50%; right: -100px; top: -150px; background: rgba(255,255,255,.11); }
.welcome-copy { position: relative; z-index: 1; max-width: 720px; text-align: left; }
.welcome-kicker { font-size: .76rem; text-transform: uppercase; font-weight: 800; letter-spacing: .12em; color: rgba(255,255,255,.72); }
.welcome-copy h1 { margin: .55rem 0 .55rem; font-size: clamp(1.9rem, 4vw, 3.1rem); font-weight: 770; }
.welcome-copy p { margin: 0; max-width: 580px; color: rgba(255,255,255,.84); font-size: 1rem; line-height: 1.6; }
.welcome-icon { position: relative; z-index: 1; width: 92px; height: 92px; min-width: 92px; border-radius: 24px; display: grid; place-items: center; background: rgba(255,255,255,.14); font-size: 2.5rem; }
.section-heading { display: flex; justify-content: space-between; align-items: end; gap: 1rem; text-align: left; }
.section-heading h2 { margin: 0; font-size: 1.25rem; font-weight: 750; }
.section-heading p { margin: .25rem 0 0; color: var(--qhatu-muted); font-size: .9rem; }
.access-count { white-space: nowrap; background: var(--qhatu-primary-soft); color: var(--qhatu-primary); border-radius: 999px; padding: .45rem .75rem; font-size: .78rem; font-weight: 700; }
.search-strip { display: grid; gap: .45rem; padding: .9rem 1rem; }
.search-box { display: flex; align-items: center; gap: .65rem; min-height: 50px; padding: 0 .95rem; border: 1px solid var(--qhatu-border); border-radius: 14px; background: #fff; }
.search-box i { color: #8ca0b5; font-size: 1rem; }
.search-box input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; color: var(--qhatu-text); font-size: .95rem; }
.search-box input::placeholder { color: #93a4b8; }
.search-clear { width: 34px; height: 34px; border: 0; border-radius: 10px; background: #eef4fa; color: #66809c; display: grid; place-items: center; }
.search-clear:hover { background: #e2ebf4; }
.search-help { color: var(--qhatu-muted); font-size: .78rem; text-align: left; }
.access-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 1rem; }
.access-card { width: 100%; border: 1px solid var(--qhatu-border); background: #fff; cursor: pointer; font: inherit; position: relative; min-height: 150px; display: flex; align-items: flex-start; gap: 1rem; padding: 1.25rem; text-decoration: none; color: var(--qhatu-text); text-align: left; transition: transform .2s, box-shadow .2s, border-color .2s; }
.access-card:hover { transform: translateY(-3px); border-color: #bdd4ec; box-shadow: 0 16px 34px rgba(26,54,93,.12); color: var(--qhatu-text); }
.access-icon { width: 48px; height: 48px; min-width: 48px; border-radius: 14px; display: grid; place-items: center; background: var(--qhatu-primary-soft); color: var(--qhatu-primary); font-size: 1.25rem; }
.access-copy { min-width: 0; padding-right: 1.25rem; }
.module-name { color: var(--qhatu-primary); font-size: .68rem; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
.access-copy h3 { margin: .35rem 0 .45rem; font-size: 1rem; font-weight: 720; line-height: 1.35; }
.access-copy p { margin: 0; color: var(--qhatu-muted); font-size: .8rem; }
.access-arrow { position: absolute; right: 1rem; top: 1rem; color: #9aa8ba; }
.empty-card { padding: 3rem 1.5rem; text-align: center; }
.empty-icon { margin: 0 auto 1rem; width: 58px; height: 58px; display: grid; place-items: center; border-radius: 18px; background: var(--qhatu-primary-soft); color: var(--qhatu-primary); font-size: 1.5rem; }
.empty-card h3 { margin: 0 0 .4rem; font-size: 1.05rem; }
.empty-card p { margin: 0; color: var(--qhatu-muted); }
.help-strip { display: flex; align-items: center; gap: 1rem; padding: 1rem 1.2rem; text-align: left; }
.help-icon { width: 44px; height: 44px; min-width: 44px; display: grid; place-items: center; border-radius: 13px; background: #e9f8f4; color: #16866f; font-size: 1.2rem; }
.help-strip strong { font-size: .9rem; }
.help-strip p { margin: .15rem 0 0; color: var(--qhatu-muted); font-size: .82rem; }
@media (max-width: 575.98px) {
  .home-page { gap: 1rem; }
  .welcome-card { min-height: 190px; padding: 1.35rem; }
  .welcome-icon { display: none; }
  .section-heading { align-items: center; }
  .search-strip { padding: .8rem; }
  .search-box { min-height: 46px; padding: 0 .8rem; }
  .access-grid { grid-template-columns: 1fr; }
  .access-card { min-height: 132px; padding: 1rem; }
  .help-strip { align-items: flex-start; }
}
</style>
